import React from 'react';
import classNames from 'classnames';
import { iconComponents, IconComponentsObject } from '@/components/ui/Icon/IconComponents';
import { Size } from '@/types/enums';

import styles from './Icon.module.css';

type IconProps = {
  iconName: keyof IconComponentsObject;
  size?: Size
  onClick?: () => void;
};

const iconSizeStyles: Partial<Record<Size, string>> = {
  EXTRA_SMALL: styles['icon--extra-small'],
  SMALL: styles['icon--small'],
  MEDIUM: styles['icon--medium'],
  LARGE: styles['icon--large'],
  EXTRA_LARGE: styles['icon--extra-large'],
};

export default function Icon(
  {
    iconName,
    size = Size.SMALL,
    onClick,
  }: IconProps,
): React.ReactElement {
  return (
    <i
      className={classNames(
        styles.icon,
        iconSizeStyles[size],
      )}
      onClick={onClick}
    >
      {iconName && iconComponents[iconName] && React.createElement(iconComponents[iconName])}
    </i>
  );
}
